import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';


// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

//-----------------------|| ROUTING RENDER ||-----------------------//

const AppRoutes = () => {
    const account = useSelector((state) => state.account);
    const { isLoggedIn } = account
    var redirect_url = "/dashboard";
    
    return (<>
        <Routes>
            <Route path="/" element={<Navigate to={redirect_url} />} />
        </Routes>
        <LoginRoutes />
        <MainRoutes />
    </>);
};

export default AppRoutes;
